
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["fill",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","class":"fill","fill":"transparent","stroke":"currentColor","viewBox":"0 0 50.147 50.147"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10.548","cy":"10.548","r":"10.548","transform":"rotate(-7.47 97.67 -95.504)"}}),_c('path',{attrs:{"d":"M25.07 38.556c-7.445 0-13.108 1.86-16.505 5.385a25.048 25.048 0 0033.01 0c-3.398-3.525-9.057-5.385-16.505-5.385z"}}),_c('path',{attrs:{"d":"M12.403 38.512a36.053 36.053 0 0125.345 0 17.32 17.32 0 015.526 3.8 25.074 25.074 0 10-36.4 0 17.281 17.281 0 015.529-3.8zM25.075 8.083a12.892 12.892 0 11-12.892 12.892 12.906 12.906 0 0112.89-12.892z"}})])
          )
        }
      }
    